import React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { getLoggedUser } from 'src/helper/localStore/getLoggedUser'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()
  const loggedUser = getLoggedUser()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout sx={{ p: 0 }}>
      <CardCommon title={translate('ra.entity.user')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={record.id} />
          <ShowListElement label={translate('ra.field.firstname')} value={record.firstname} />
          <ShowListElement label={translate('ra.field.surname')} value={record.surname} />
          <ShowListElement label={translate('ra.field.email')} value={record.mail} />
          <ShowListElement label={translate('ra.field.username')} value={record.username} />
          {(loggedUser?.is_admin || loggedUser?.is_superadmin) && (
            <>
              <ShowListElement
                label={translate('ra.field.is_admin')}
                value={record.is_admin}
                type='boolean'
              />
            </>
          )}
          {loggedUser?.is_superadmin && (
            <>
              <ShowListElement
                label={translate('ra.field.is_superadmin')}
                value={record.is_superadmin}
                type='boolean'
              />
            </>
          )}
          {record.is_active && (<ShowListElement
              label={translate('ra.field.is_active')}
              value={record.is_active}
              type='boolean'
            />
            )}
          {record.language && (
            <ShowListElement
                label={translate('ra.field.language')}
                value={record.language}
              />
            )}
          {record.is_staff && (
            <ShowListElement
                label={translate('ra.field.is_staff')}
                value={record.is_staff}
                type='boolean'
              />
            )}
          {record.created_at && (
            <ShowListElement
                label={translate('ra.field.created_at')}
                value={record.created_at}
                type='date'
                includeTime={true}
              />
          )}
          {record.updated_at && (
            <ShowListElement
                label={translate('ra.field.updated_at')}
                value={record.updated_at}
                type='date'
                includeTime={true}
              />
          )}
          {record.all_devices && (
          <ShowListElement
              label={translate('ra.field.all_devices')}
              value={record.all_devices}
              type='boolean'
            />
          )}

        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const UserShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
